module.exports = function browserDetect() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('edge') > -1) {
    return 'edge';
  }
  if (/ipad|iphone|ipod/.test(ua) && !window.MSStream) {
    return 'ios';
  }
  if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') > -1) {
      return 'chrome';
    }
    return 'safari';
  }
  if (ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1) {
    return 'ie';
  }
  if (ua.indexOf('firefox') > -1) {
    return 'mozilla';
  }
  return 'standard';
};



// WEBPACK FOOTER //
// ./src/helpers/browserDetect.js